import { ToolName } from '../Types/enums';

export const ToolConfig = {
  [ToolName.WEB_SEARCH]: {
    name: 'Web Search',
    deepResearchSupport: true,
  },
  [ToolName.DEEP_RESEARCH]: {
    name: 'Deep Research',
    deepResearchSupport: true,
  },
  [ToolName.GLEAN_SEARCH]: {
    name: 'Glean Search',
    deepResearchSupport: false,
  },
  [ToolName.STRACL_MCP]: {
    name: 'Stracl MCP',
    deepResearchSupport: false,
  },
  [ToolName.SEARCH_SHAREPOINT_FILES]: {
    name: 'Search Sharepoint Files',
    deepResearchSupport: false,
  },
  [ToolName.SEARCH_SHAREPOINT_SITES]: {
    name: 'Search Sharepoint Sites',
    deepResearchSupport: false,
  },
  [ToolName.SEARCH_SHAREPOINT_FOLDERS]: {
    name: 'Search Sharepoint Folders',
    deepResearchSupport: false,
  },
  [ToolName.SEARCH_INTELLIO_DATA]: {
    name: 'Search Intellio Insights Infrastructure Rubric Data',
    deepResearchSupport: false,
  },
  [ToolName.SEARCH_INTELLIO_MCS_MODEL_LINE_DETAILS]: {
    name: 'Search Intellio Insights MCS Model Line Details',
    deepResearchSupport: false,
  },
  [ToolName.SEARCH_INTELLIO_MCS_SUMMARY_DATA]: {
    name: 'Search Intellio Insights MCS Summary Data',
    deepResearchSupport: false,
  },
  [ToolName.SEARCH_INTELLIO_KPI_LIST]: {
    name: 'Search Intellio Insights KPI List',
    deepResearchSupport: false,
  },
  [ToolName.SEARCH_INTELLIO_MA_GENAI_DILIGENCE_SSA_DETAIL]: {
    name: 'Search Intellio Insights M&A Genai Diligence SSA Detail',
    deepResearchSupport: false,
  },
  [ToolName.SEARCH_INTELLIO_MA_GENAI_DILIGENCE_SSA_AGGREGATE]: {
    name: 'Search Intellio Insights M&A Genai Diligence SSA Aggregate',
    deepResearchSupport: false,
  },
  [ToolName.SEARCH_INTELLIO_SCHEMAS]: {
    name: 'Search Intellio Schemas',
    deepResearchSupport: false,
  },
  [ToolName.SEARCH_INTELLIO_QUERY]: {
    name: 'Search Intellio Query',
    deepResearchSupport: false,
  },
};

export const resolveToolDeletion = (
  toolToDelete: ToolName,
  appliedTools: ToolName[]
): ToolName[] => {
  // Remove Deep Research + Web Search together
  if (toolToDelete === ToolName.DEEP_RESEARCH) {
    return appliedTools.filter((t) => t !== ToolName.DEEP_RESEARCH && t !== ToolName.WEB_SEARCH);
  }

  // Prevent removing Web Search while Deep Research is active
  if (toolToDelete === ToolName.WEB_SEARCH && appliedTools.includes(ToolName.DEEP_RESEARCH)) {
    return appliedTools;
  }

  // Default single removal
  return appliedTools.filter((t) => t !== toolToDelete);
};

export const handleToolDelete = (
  toolToDelete: ToolName,
  appliedTools: ToolName[],
  onChange: (newTools: ToolName[]) => void
) => {
  // Prevent removing Web Search while Deep Research is active
  if (toolToDelete === ToolName.WEB_SEARCH && appliedTools.includes(ToolName.DEEP_RESEARCH)) {
    return undefined;
  }

  return () => {
    const newTools = resolveToolDeletion(toolToDelete, appliedTools);
    onChange(newTools);
  };
};
